export default function (url) {
    if (url === void 0) { url = ''; }
    if (!url) {
        return [];
    }
    var smarttagsByKey = url
        .split(',')
        .reduce(function (acc, smarttag) {
        var _a = decodeURIComponent(smarttag).split(':'), key = _a[0], value = _a[1], rest = _a[2];
        // smarttag should have only two parts
        if (typeof rest === 'undefined') {
            var val = {
                key: value,
            };
            if (acc[key]) {
                acc[key].values.push(val);
            }
            else {
                acc[key] = {
                    key: key,
                    values: [val],
                };
            }
        }
        // otherwise continue
        return acc;
    }, {});
    return Object.keys(smarttagsByKey).map(function (k) { return smarttagsByKey[k]; });
}
